/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getPaymentPunchoutCallbackPage = (props: IncomingContent): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'CheckoutHeader', id: 'checkout_header' }],
		first: [{ name: 'PunchoutPaymentCallBack', id: 'PunchoutPaymentCallBack' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
